import { useState, useEffect } from "react";

import { App, Button } from "antd";

import {
  isNotificationsSupported,
  isFirebaseMessagingSupported,
  requestNotificationsPermission,
} from "../../../helpers/notification";

import { NOTIFICATION_PERMISSION } from "../../../constants/notification";

import "./AskForNotifications.scss";

function AskForNotifications(props) {
  const { onAccept, onReject } = props;

  const [isSupported, setIsSupported] = useState(false);

  const { notification } = App.useApp();

  async function acceptHandler() {
    notification.destroy();
    const permission = await requestNotificationsPermission();
    if (permission === NOTIFICATION_PERMISSION.GRANTED) {
      onAccept();
    }
  }

  function rejectHandler() {
    notification.destroy();
    onReject();
  }

  useEffect(() => {
    async function checkNotificationsSupport() {
      const isBrowserSupports = isNotificationsSupported();
      const isFirebaseSupports = await isFirebaseMessagingSupported();
      if (isBrowserSupports && isFirebaseSupports) {
        setIsSupported(true);
      }
    }

    checkNotificationsSupport();
  }, []);

  useEffect(() => {
    if (isSupported) {
      const { permission } = Notification;
      if (permission === NOTIFICATION_PERMISSION.GRANTED) {
        onAccept();
      } else if (permission === NOTIFICATION_PERMISSION.DEFAULT) {
        notification.open({
          className: "ask-for-notifications",
          message: "الإشعارات",
          description: "هل تريد السماح بإرسال الإشعارات ؟",
          placement: "topRight",
          duration: null,
          btn: (
            <div className="d-flex justify-content-between align-items-center">
              <Button type="primary" size="small" onClick={acceptHandler}>
                موافق
              </Button>
              <Button type="secondary" size="small" onClick={rejectHandler}>
                غير موافق
              </Button>
            </div>
          ),
        });
      } else {
        console.warn("Notificationa are already denied by the user !");
      }
    }
    // eslint-disable-next-line
  }, [isSupported]);
}

export default AskForNotifications;
